'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.state = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _subscribers = require('./subscribers');

var _handlers = require('./handlers');

var _product = require('./product');

var _collection = require('./collection');

var _lineItem = require('./line-item');

var _cart = require('./cart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = exports.state = window.bvaccel.state;

var init = function init(data) {
  (0, _cart.cacheCart)();

  return [].concat((0, _toConsumableArray3.default)((0, _product.initProductContainers)(data)), (0, _toConsumableArray3.default)((0, _collection.initCollectionContainers)(data)), (0, _toConsumableArray3.default)((0, _lineItem.initLineItemContainers)(data)));
};

exports.default = {
  initSubscribers: _subscribers.initSubscribers,
  init: init,
  get: _handlers.getState,
  set: _handlers.setState,
  clear: _handlers.clearState
};